<template>
  <div v-if="selectedFilter && selectedFilter.filter">
    <div
      v-if="selectedFilter.filter.type === 'select' && selectedFilter.values"
      class="row q-gutter-y-sm q-pa-sm"
      style="max-height: 300px; overflow-y: auto"
    >
      <q-select
        transition-duration="100"
        :model-value="selectedFilter.values"
        label="is any of"
        class="full-width"
        dense
        use-chips
        use-input
        outlined
        input-debounce="0"
        multiple
        :options="selectOptions"
        @filter="filterFn"
        @update:model-value="$emit('update:values', $event)"
      />
    </div>
    <div v-else-if="selectedFilter.filter.type === 'range'" class="row q-gutter-sm q-pa-sm">
      <q-input
        label="Min"
        :model-value="selectedFilter.minValue as number"
        class="col"
        dense
        outlined
        type="number"
        @update:model-value="$emit('update:minValue', parseFloat($event as string))"
      />
      <q-input
        label="Max"
        :model-value="selectedFilter.maxValue as number"
        class="col"
        dense
        outlined
        type="number"
        @update:model-value="$emit('update:maxValue', parseFloat($event as string))"
      />
    </div>
    <div v-else-if="selectedFilter.filter.type === 'date'" class="row q-gutter-sm q-pa-sm">
      <date-range-picker
        :date-range="{
          from: selectedFilter.minValue as Date | null,
          to: selectedFilter.maxValue as Date | null
        }"
        :title="selectedFilter.filter.label"
        :use-date-constraints="false"
        :footer="false"
        btn-label="Listings last seen date"
        class="col"
        @update="updateDateRange"
      />
    </div>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import type { ActiveUnitFilter } from '@/types/propertyReports'

export default {
  name: 'FilterPopover',
  components: { DateRangePicker },
  props: {
    selectedFilter: {
      type: Object as PropType<ActiveUnitFilter>,
      default: null
    }
  },
  emits: ['update:values', 'update:minValue', 'update:maxValue'],
  data() {
    return {
      selectOptions: [] as (string | number)[]
    }
  },
  created() {
    this.selectOptions = this.selectedFilter?.filter?.options || []
  },
  methods: {
    filterFn(val: string, update: (cbk: () => void) => void) {
      update(() => {
        const search = val.toLowerCase()
        this.selectOptions = (this.selectedFilter?.filter?.options || []).filter((v) =>
          String(v).toLowerCase().includes(search)
        )
      })
    },
    updateDateRange(obj: { from: Date; to: Date }) {
      this.$emit('update:minValue', obj.from)
      this.$emit('update:maxValue', obj.to)
    }
  }
}
</script>
